/** @jsxImportSource @emotion/react */
import React, { FC, useMemo } from 'react';

import { unavailableStationAndConnectorStatuses } from '../../../../constants';
import { ILocation } from '../../../../api/locations/types';
import { IStation } from '../../../../api/station/types';
import { isStationUnavailable } from '../../../../utils/station';

import setConnectorStyles from './set-connector.styles';
import Connector from './connector.component';
import { ISetUpState } from '../../set-up.types';
import { getAllConnectors } from '../../utils/getAllConnectors';

type PropTypes = {
    location?: ILocation;
    onPress: (connector: ISetUpState['connector'] & { station: IStation }) => void;
    isConnectorPage?: boolean;
};

export const SetConnector: FC<PropTypes> = props => {
    const { location, onPress, isConnectorPage = false } = props;

    const allConnectors = useMemo(() => getAllConnectors({ location }), [location]);

    return (
        <div css={setConnectorStyles.content}>
            {allConnectors.map(connector => {
                const isUnavailable =
                    unavailableStationAndConnectorStatuses.includes(connector.status) ||
                    isStationUnavailable(connector.station) ||
                    connector.mode === 'Inoperative';
                return (
                    <Connector
                        connector={connector}
                        onPress={onPress}
                        station={connector.station}
                        key={`${connector.station._id}-${connector._id}`}
                        isUnavailable={isUnavailable}
                        location={location}
                    />
                );
            })}
        </div>
    );
};
